export const firebaseConfig = {
  apiKey: "AIzaSyBwyn64U5V7QwjXZae-RPDQ8WdovO8zsAc",
  authDomain: "termsheet.dorado.com.au",
  databaseURL: "https://term-sheet-automation.firebaseio.com",
  projectId: "term-sheet-automation",
  storageBucket: "term-sheet-automation.appspot.com",
  messagingSenderId: "127446651995",
  appId: "1:127446651995:web:4541cf95bdff914b"
};